import store from '@/store';
import { USER_REQUEST } from '@/store/actions/user';
import { CLINIC_AUTH } from '@/store/modules/user';

async function clinicGuard(next) {
  if (store.getters.isProfileLoaded) { return true; }
  try {
    await store.dispatch(USER_REQUEST);
  } catch (error) {
    next('/login');
    return false;
  }
  return true;
}

async function isMobile() {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];
  return toMatch.some((toMatchItem) => navigator.userAgent.match(toMatchItem));
}

async function guard(to, from, next) {
  if (!to.name) {
    next({ name: 'Auth' });
    return;
  }
  const authGroups = to.matched.flatMap(({ meta }) => ('authOf' in meta ? [meta.authOf] : []));
  if (authGroups.includes(CLINIC_AUTH)) {
    const isSuccess = await clinicGuard(next);
    if (!isSuccess) {
      return;
    }
  }
  const isAllowed = authGroups.every((group) => group === store.getters.authOf);
  if (isAllowed) {
    next();
  } else {
    next('/login');
  }
  if (to.name === 'ClinicPanelAppointmentScheduleEmployees' && store.getters.isNeedRedirect) {
    next(store.getters.getScheduleRedirect);
  }

  if ((to.name === 'Registration' || to.name === 'Auth') && store.getters.isAuthenticated && await isMobile()) {
    next({ name: 'ClinicPanelAppointmentScheduleEmployees' });
  }
}

export default guard;
